import { useMutation, gql } from "@apollo/client";

export const ADD_NOTIFICATION = gql`
  mutation addNotification($body: String, $status: String!, $title: String!) {
    addNotification(body: $body, status: $status, title: $title) @client
  }
`;

type NotificationInputs = {
  title: string;
  body?: string;
  status: "success" | "warning" | "error";
};

export default (options = {}) => {
  return useMutation<{}, NotificationInputs>(ADD_NOTIFICATION, options);
};
